import {
  companyAssetsViewColumns,
  companyAssetsSearchSchema,
  mapCompanyAssetsViewQuery,
} from "./CompanyAssetsView.default";
import ManagedGridView from "../controls/ManagedGridView";
import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import { PaginationInput } from "../repository/data.default";
import { getCompanyAssets } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

export interface CompanyAssetsViewProps {
  readonly companyUid: string;
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function CompanyAssetsView(props: CompanyAssetsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  // Always scope to this company's assets by injecting a companyUid condition ahead of any search conditions.
  const scopedRequest = createGridRequest(
    (input: PaginationInput) =>
      getCompanyAssets({
        ...input,
        searchQuery: {
          conditions: [
            { field: "companyUid", operation: QueryOperation.Equal, values: [props.companyUid] },
            ...(input.searchQuery?.conditions ?? []),
          ],
        },
      }),
    { retry: true },
  );

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={companyAssetsViewColumns}
      schema={companyAssetsSearchSchema}
      mapQuery={mapCompanyAssetsViewQuery}
      onSearch={props.onSearch}
      request={scopedRequest}
      actions={[
        {
          key: "metrics",
          label: "View metrics",
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("CompanyAssets", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("CompanyAssets", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default CompanyAssetsView;
